export function numberOrUndefined(input: string | null | undefined) {
  if (input === null || input === undefined) return undefined

  const coercedToNumber = Number(input)
  if (Number.isNaN(coercedToNumber)) return undefined

  return coercedToNumber
}
